import {
  Alert,
  Autocomplete,
  Card,
  Grid,
  Snackbar,
  TextareaAutosize,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import axios from "axios";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useQuery } from "@tanstack/react-query";
import MDAutocomplete from "components/MDAutocomplete";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { use, useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import DayjsUtils from "@date-io/dayjs";
import dayjs from "dayjs";
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import TextField from '@mui/material/TextField';

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { compressImage } from "utils/imageCompression";

const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "2px 8px",
  color: "white",
  backgroundColor: "#90B494",
}));

const GroupItems = styled("ul")({
  padding: 0,
});

function LeaveRequest() {
  const navigate = useNavigate();
  const [state, setState] = useState({
    open: false,
    severity: "success",
    vertical: "top",
    horizontal: "right",
    message: "",
  });
  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const { vertical, horizontal, open, message, severity } = state;
  const [loading, setLoading] = useState(false);
  const [leaveType, setLeaveType] = useState("");
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  useEffect(() => {
    formik.setFieldValue("txtLeaveType", leaveType);
    setSelectedFiles([]);
  }, [leaveType]);

  const fetchDistrict = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/districts/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  const {
    data: districtData = [],
    error: districtError,
    isLoading: districtIsLoading,
  } = useQuery({
    queryKey: ["fetchDistrict"],
    queryFn: fetchDistrict,
    retry: false,
  });

  const me = async () => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/me`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    // console.log("🚀 ~ fetchUsers ~ response:", response);
    return response.data;
  };

  const {
    data: meData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["me"], // Unique key for the query
    queryFn: me, // The async function to run
    retry: false,
  });

  const validationSchema = () => {
    return Yup.object().shape({
      txtStartDate: Yup.string().required("Start Date is required"),
      txtEndDate: Yup.string().required("End Date is required"),
      txtLeaveType: Yup.string().required("Leave Type is required"),
      txtReason: Yup.string()
        .required("Leave Reason is required")
        .min(3, "Leave Reason must be at least 3 characters")
        .max(500, "Leave Reason must be at most 500 characters"),
    });
  };

  const formik = useFormik({
    initialValues: {
      txtStartDate: "",
      txtEndDate: "",
      txtLeaveType: "",
      txtReason: "",
    },
    validationSchema: validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      if (["Casual Leave", "Sick Leave"].includes(leaveType) && selectedFiles.length === 0) {
        setState({
          ...state,
          open: true,
          severity: "error",
          message: `Please select at least one document for ${leaveType} application`,
        });
        return;
      }
      setLoading(true);
      try {
        let submitData;
        let headers = {};

        if (selectedFiles.length > 0) {
          const formData = new FormData();
          formData.append("values", JSON.stringify(values));
          
          // Compress all images before adding to Form Data
          const compressedFiles = await Promise.all(
            selectedFiles.map(file => compressImage(file))
          );

          compressedFiles.forEach((file) => {
            formData.append("documents", file);
          });
          submitData = formData;
          headers["Content-Type"] = "multipart/form-data";
        } else {
          submitData = { values };
          headers["Content-Type"] = "application/json";
        }

        await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_URL}/leave-request/add`,
          data: submitData,
          headers: headers,
          withCredentials: true,
        })
          .then(function (response) {
            if (response.data.status === 200) {
              setState({
                ...state,
                open: true,
                severity: "success",
                message: response.data.message,
              });

              setTimeout(() => {
                navigate("/leave-list");
              }, 2000);
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.status === 401) {
              setState({
                ...state,
                open: true,
                severity: "error",
                message: error.response.data.error,
              });
            } else if (error.status === 500) {
              console.log(error.response.data.error);
              setState({
                ...state,
                open: true,
                severity: "error",
                message: error.response.data.error,
              });
              // } else if (error.status === 400) {
            } else if (error.status === 500) {
              setState({
                ...state,
                open: true,
                severity: "error",
                message: error.response.data.error,
              });
            } else if (error.status === 400) {
              console.log(error.response.data.details.intDistrict);
              if (error.response?.data?.details) {
                const serverErrors = {};

                if (error.response.data.details.intDistrict) {
                  serverErrors.intDistrict = error.response.data.details.intDistrict[0];
                }
                if (error.response.data.details.txtGroup) {
                  serverErrors.txtGroup = error.response.data.details.txtGroup[0];
                }
                if (error.response.data.details.txtSchoolName) {
                  serverErrors.txtSchoolName = error.response.data.details.txtSchoolName[0];
                }

                formik.setErrors(serverErrors);
              }
            }
          });
      } catch (error) {
        console.log("error :", error);
        console.error(error.status);
      } finally {
        setLoading(false); // hide loader
      }
    },
  });

  const fetchCasualLeaveStatus = async () => {
    if (!meData?.user_id) {
      return { status: 200, data: [] };
    }

    try {
      const queryParams = new URLSearchParams({
        page: 1,
        limit: 100,
        user_id: meData.user_id,
        role_id: meData.role_id,
        start_date: dayjs().subtract(1, 'year').startOf("year").format("YYYY-MM-DD"),
        end_date: dayjs().add(1, 'year').endOf("year").format("YYYY-MM-DD"),
      });

      const url = `${process.env.REACT_APP_API_URL}/leave-request?${queryParams.toString()}`;
      const response = await axios.get(url, { withCredentials: true });
      return response.data;
    } catch (error) {
      console.error("Error fetching leave status:", error);
      return { status: 200, data: [] };
    }
  };

  const { data: casualLeaveData, isLoading: isCasualLeaveLoading } = useQuery({
    queryKey: ["casualLeaveStatus", meData?.user_id],
    queryFn: fetchCasualLeaveStatus,
    enabled: !!meData?.user_id,
  });

  const casualLeaveUsed = useMemo(() => {
    if (
      !casualLeaveData ||
      !Array.isArray(casualLeaveData.data) ||
      casualLeaveData.data.length === 0
    ) {
      return false;
    }

    const selectedDate = formik.values.txtStartDate ? dayjs(formik.values.txtStartDate) : dayjs();

    const used = casualLeaveData.data.some((leave) => {
      const type = (leave.leave_type || "").trim().toLowerCase();
      const leaveDate = dayjs(leave.start_date);

      return (
        type === "casual leave" &&
        leaveDate.isSame(selectedDate, "month") &&
        (leave.status === "Approved" || leave.status === "Pending")
      );
    });

    return used;
  }, [casualLeaveData, formik.values.txtStartDate]);

  const appliedDates = useMemo(() => {
    if (!casualLeaveData || !Array.isArray(casualLeaveData.data)) return [];
    const dates = [];
    casualLeaveData.data.forEach((leave) => {
      if (leave.status === "Approved" || leave.status === "Pending") {
        let current = dayjs(leave.start_date);
        const end = dayjs(leave.end_date);
        while (current.isSameOrBefore(end, "day")) {
          dates.push(current.format("YYYY-MM-DD"));
          current = current.add(1, "day");
        }
      }
    });
    return dates;
  }, [casualLeaveData]);

  const shouldDisableDate = (date) => {
    return appliedDates.includes(dayjs(date).format("YYYY-MM-DD"));
  };



  const leaveOptions = [
    { title: "On Duty" },
    { title: "Sick Leave" },
    { title: "Casual Leave" },
    // { title: "Paid Leave" },
  ];

  if (meData && (meData.role_id === 1 || meData.role_id === 2)) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        flexDirection="column"
      >
        <Typography variant="h4" color="error">
          403 - Unauthorized
        </Typography>
        <Typography>You are not authorized to access this page.</Typography>
      </Box>
    );
  }

  // const [value, setValue] = useState(dayjs("2022-04-17"));
  return (
    <DashboardLayout>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          variant="filled"
          sx={{ width: "100%" }}
          style={{ color: "white" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Backdrop open={loading} sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card id="delete-account">
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h5" fontWeight="medium">
            Leave Request
          </MDTypography>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                Start Date <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={startDateOpen}
                  onOpen={() => setStartDateOpen(true)}
                  onClose={() => setStartDateOpen(false)}
                  format="DD/MM/YYYY"
                  minDate={dayjs()}
                  value={formik.values.txtStartDate ? dayjs(formik.values.txtStartDate) : null}
                  shouldDisableDate={shouldDisableDate}
                  onChange={(value) => formik.setFieldValue("txtStartDate", value)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      error: formik.touched.txtStartDate && Boolean(formik.errors.txtStartDate),
                      helperText: formik.touched.txtStartDate && formik.errors.txtStartDate,
                      onClick: () => setStartDateOpen(true),
                      InputProps: {
                        sx: {
                          fontSize: "14px",
                          height: "45px",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                End Date<span style={{ color: "red" }}>*</span>
              </MDTypography>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={endDateOpen}
                  onOpen={() => setEndDateOpen(true)}
                  onClose={() => setEndDateOpen(false)}
                  format="DD/MM/YYYY"
                  minDate={formik.values.txtStartDate || dayjs()}
                  value={formik.values.txtEndDate ? dayjs(formik.values.txtEndDate) : null}
                  shouldDisableDate={shouldDisableDate}
                  onChange={(value) => formik.setFieldValue("txtEndDate", value)}
                  error={formik.touched.txtEndDate && Boolean(formik.errors.txtEndDate)}
                  helperText={formik.touched.txtEndDate && formik.errors.txtEndDate}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      error: formik.touched.txtEndDate && Boolean(formik.errors.txtEndDate),
                      helperText: formik.touched.txtEndDate && formik.errors.txtEndDate,
                      onClick: () => setEndDateOpen(true),
                      InputProps: {
                        sx: {
                          fontSize: "14px",
                          height: "45px",
                          cursor: "pointer",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                Leave Type <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <Autocomplete
                value={leaveType || null}
                options={leaveOptions.map((o) => o.title)}
                onChange={(event, newValue) => {
                  setLeaveType(newValue || "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Option"
                    size="small"
                    error={Boolean(formik.errors.txtLeaveType)}
                    helperText={formik.errors.txtLeaveType}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "45px", // ✅ same as DatePicker
                      },
                      "& .MuiInputBase-input": {
                        padding: "10px 14px", // ✅ vertical alignment
                        fontSize: "14px",
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              {["Casual Leave", "Sick Leave"].includes(leaveType) && (
                <Box mb={2}>
                  {isCasualLeaveLoading ? (
                    <Alert severity="info" variant="filled">
                      Checking Casual Leave status...
                    </Alert>
                  ) : casualLeaveUsed ? (
                    <Alert severity="warning" variant="filled">
                      “You have exceeded your casual leave limit of one per month. After exceeding
                      the casual leave, your salary will be deducted for the number of days absent.”
                    </Alert>
                  ) : (
                    <Alert severity="info" variant="filled">
                      You have 1 Casual Leave available for this month.
                    </Alert>
                  )}
                </Box>
              )}
            </Grid>
            {["Casual Leave", "Sick Leave"].includes(leaveType) && (
              <Grid item xs={12} size={{ xs: 12 }}>
                <Box mb={2}>
                  <MDTypography style={{ fontSize: "16px" }} color="dark">
                    Upload Documents <span style={{ color: "red" }}>*</span>
                  </MDTypography>
                  <Box
                    sx={{
                      border: "2px dashed #90B494",
                      borderRadius: "8px",
                      padding: "20px",
                      textAlign: "center",
                      backgroundColor: "#f9fbf9",
                      cursor: "pointer",
                      display: "block",
                      "&:hover": {
                        backgroundColor: "#f0f7f0",
                      },
                    }}
                    component="label"
                  >
                    <input
                      type="file"
                      multiple
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const files = Array.from(e.target.files);
                        setSelectedFiles((prev) => [...prev, ...files]);
                      }}
                    />
                    <MDTypography variant="body2" color="text">
                      Drag & Drop files here, or <strong>Click to Browse</strong>
                    </MDTypography>
                  </Box>
                  {selectedFiles.length > 0 && (
                    <Box mt={2} display="flex" flexDirection="column" gap={1}>
                      {selectedFiles.map((file, idx) => (
                        <Box
                          key={idx}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          p={1}
                          sx={{
                            backgroundColor: "#fff",
                            border: "1px solid #e0e0e0",
                            borderRadius: "4px",
                          }}
                        >
                          <MDTypography variant="body2" fontWeight="medium">
                            {file.name}
                          </MDTypography>
                          <MDButton
                            color="error"
                            size="small"
                            onClick={() => {
                              setSelectedFiles((prev) => prev.filter((_, i) => i !== idx));
                            }}
                            sx={{ minHeight: "30px", height: "30px" }}
                          >
                            Remove
                          </MDButton>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              </Grid>
            )}
          </Grid>
          <Grid item size={{ xs: 12, md: 4 }}>
            <MDTypography style={{ fontSize: "16px" }} color="dark">
              Reason <span style={{ color: "red" }}>*</span>
            </MDTypography>
            <TextField
              name="txtReason"
              error={Boolean(formik.errors.txtReason)}
              fullWidth
              multiline
              rows={4}
              onChange={formik.handleChange("txtReason")}
              // helperText={formik.errors.txtReason}
              placeholder="Enter Reason"
              inputProps={{ maxLength: 500 }}
              helperText={
                formik.errors.txtReason
                  ? formik.errors.txtReason
                  : `${(formik.values.txtReason || "").length} / 500`
              }
              FormHelperTextProps={{
                sx: {
                  textAlign: "right",
                  marginRight: 0,
                  display: "block",
                  fontSize: "0.75rem", // optional
                },
              }}
            />
          </Grid>
        </MDBox>

        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} textAlign="right">
              <MDButton
                // color="#2f2f34 !important"
                onClick={formik.handleSubmit}
                disabled={loading}
                sx={{
                  color: "white !important",
                  backgroundColor: "#16610E",
                  "&:hover": {
                    backgroundColor: "#1f1f22", // optional: darker on hover
                  },
                }}
              >
                {loading ? "Submitting..." : "Submit"}
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default LeaveRequest;
